export const ON_FILE_ADD = '@ARI/Questionnaire/File/ON_FILE_ADD';
export const ON_FILE_REMOVE = '@ARI/Questionnaire/File/ON_FILE_REMOVE';
export const SET_FILE_VALIDATORS = '@ARI/Questionnaire/File/SET_FILE_VALIDATORS';
export const SET_FILE_VALUES = '@ARI/Questionnaire/File/SET_FILE_VALUES';
export const SET_FILE_SETTINGS = '@ARI/Questionnaire/File/SET_FILE_SETTINGS';
export const SET_FILE_ERRORS = '@ARI/Questionnaire/File/SET_FILE_ERRORS';